<template>
    <div>
        <div class="card my-3">
            <div class="card-header">证书信息查询</div>
            <div class="card-body" style="min-height: 650px">
                <div class="alert alert-warning" v-if="certificateData.length===0">没有获取到证书信息</div>

                <table class="table table-bordered" v-else>
                    <thead>
                    <tr>
                        <th class="text-center align-middle" style="width: 5%">序号</th>
                        <th class="text-center align-middle" style="width: 20%">证书编号</th>
                        <th class="text-center align-middle" style="width: 15%">证书日期</th>
                        <th class="text-center align-middle" style="width: 30%">项目名称</th>
                        <th class="text-center align-middle" style="width: 20%">培训基地</th>
                        <th class="text-center align-middle" style="width: 10%">查看</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(cer, index) in certificateData">
                        <td class="text-center align-middle">{{index+1}}</td>
                        <td class="text-center align-middle">{{cer.certificateId}}</td>
                        <td class="text-center align-middle">{{cer.createDateString}}</td>
                        <td class="text-left align-middle">{{cer.projectName}}</td>
                        <td class="text-left align-middle">{{cer.organName}}</td>
                        <td class="text-center align-middle">
                            <router-link class="btn btn-primary btn-sm mr-2" target="_blank" :to="{name: 'pdfView', params: {attFileId: cer.attFileId}}">查看</router-link>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import studyApi from "@/utils/api/study";
export default {
    name: "StudentCertificateManage",
    data: function () {
        return {
            studentId: this.$store.state.userInfo.userId,
            certificateData: [],
        };
    },
    mounted() {
        this.getStudentCertificateData();
    },
    methods: {
        getStudentCertificateData() {
            studyApi.certificate.getStudentCertificateData(this.studentId).then(res => {
                this.certificateData = res.data;
            });
        }
    }
}
</script>

<style scoped>

</style>